import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { Phone, ChevronLeft } from "lucide-react";
import { Progress } from "@/components/ui/progress";
import { HeaderLogo } from "@/components/AnimatedLogo";
import { SimpleLegalFooter } from "@/components/LegalFooter";

const PHONE = "01 48 20 98 27";

export const CalcShell = ({ title, stepIndex, totalSteps, onBack, stepKey, children }) => (
  <div className="min-h-screen bg-gradient-to-b from-gray-50 to-white">
    <header className="bg-white/80 backdrop-blur-sm border-b sticky top-0 z-40">
      <div className="max-w-2xl mx-auto px-4 py-3 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2">
          <HeaderLogo theme="contact" size="sm" showName={false} dark={false} />
        </Link>
        <a href={`tel:${PHONE.replace(/\s/g, "")}`} className="flex items-center gap-2 text-sm text-gray-600 hover:text-[#102692]">
          <Phone className="w-4 h-4" />
          <span className="hidden sm:inline">{PHONE}</span>
        </a>
      </div>
    </header>
    <main className="max-w-2xl mx-auto px-4 py-6">
      <h1 className="text-center text-2xl font-bold text-gray-900 mb-6" data-testid="calc-title">{title}</h1>
      {totalSteps > 0 && (
        <div className="mb-6" data-testid="calc-progress">
          <div className="flex items-center justify-between mb-2">
            <span className="text-sm text-gray-500" data-testid="calc-step-label">Étape {stepIndex + 1} sur {totalSteps}</span>
            <span className="text-sm font-medium text-[#102692]">{Math.round(((stepIndex + 1) / totalSteps) * 100)}%</span>
          </div>
          <Progress value={((stepIndex + 1) / totalSteps) * 100} className="h-2" />
        </div>
      )}
      <div className="bg-white rounded-3xl shadow-xl overflow-hidden">
        <AnimatePresence mode="wait">
          <motion.div key={stepKey} initial={{ opacity: 0, x: 20 }} animate={{ opacity: 1, x: 0 }} exit={{ opacity: 0, x: -20 }} className="p-6">
            {children}
          </motion.div>
        </AnimatePresence>
      </div>
      {onBack && (
        <button onClick={onBack} className="mt-4 flex items-center gap-1 text-sm text-gray-500 hover:text-[#102692]" data-testid="calc-back-btn">
          <ChevronLeft className="w-4 h-4" /> Retour
        </button>
      )}
    </main>
    <SimpleLegalFooter />
  </div>
);
